/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/10.webp";
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Governing Law
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
            The substantive laws of the State of California, United States of America, without reference to any conflicts of law principles that would require the application of the laws of any other jurisdiction, shall govern these Terms. The parties agree that the U.N. Convention on Contracts for the International Sale of Goods will not apply to this Agreement. Any action or proceeding arising from or relating to the Services shall be subject to the exclusive jurisdiction courts selected by Alvis International Inc. or hptechsolutions.online in the State of California, and You expressly agree to submit to the personal and exclusive jurisdiction and venue of these courts. Notwithstanding the foregoing, hptechsolutions.online may bring an action to protect or enforce its intellectual property rights in any applicable jurisdiction.
            </MKTypography></Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
